import { Box } from "@mui/material";
import BackHomeButton from "../../components/version1/BackHomeButton";
import DiscountCard from "../../components/version1/DiscountCard";
import JoinGroupButton from "../../components/version1/JoinGroupButton";
import MainContent from "../../components/version1/MainContent";
import PromoSlider from "../../components/version1/PromoSlider";

const PromoPageV1: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundImage: "url('/bg.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        width: "100%",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <BackHomeButton />
      <DiscountCard />
      <JoinGroupButton />
      {/* Main content here */}
      <MainContent />
      <PromoSlider />
    </Box>
  );
};

export default PromoPageV1;
